// Vocabulário e pesos do domínio da jornada do cliente.

export const JOURNEY_STATUS = {
  CONCLUIDA: 'concluida',
  EM_ANDAMENTO: 'em_andamento',
  PENDENTE: 'pendente',
  BLOQUEADA: 'bloqueada',
}

export const STATUS_LABEL = {
  [JOURNEY_STATUS.CONCLUIDA]: 'concluída',
  [JOURNEY_STATUS.EM_ANDAMENTO]: 'em andamento',
  [JOURNEY_STATUS.PENDENTE]: 'pendente',
  [JOURNEY_STATUS.BLOQUEADA]: 'bloqueada',
}

// Cor do chip de status, nos MESMOS tokens que a barra de etapas pinta o
// trilho. Sem `color`, o BaseStatus cai no `defaultColor` (#7C89B7) e os
// status saem no mesmo lilás — foi o que apareceu no menu de etapas do perfil.
// Sem `var()`: o BaseStatus embrulha o token sozinho (`formatColor`).
export const STATUS_COLOR = {
  [JOURNEY_STATUS.CONCLUIDA]: 'success',
  [JOURNEY_STATUS.EM_ANDAMENTO]: 'warning-new',
  [JOURNEY_STATUS.PENDENTE]: 'neutral-400',
  // Bloqueada é mais escura que pendente de propósito: as duas são cinzas, e
  // sem essa diferença a etapa travada lê como "ainda não chegou a vez".
  [JOURNEY_STATUS.BLOQUEADA]: 'neutral-600',
}

export const PRIORITY = {
  CRITICA: 'critica',
  ALTA: 'alta',
  MEDIA: 'media',
  BAIXA: 'baixa',
}

export const PRIORITY_LABEL = {
  [PRIORITY.CRITICA]: 'Crítica',
  [PRIORITY.ALTA]: 'Alta',
  [PRIORITY.MEDIA]: 'Média',
  [PRIORITY.BAIXA]: 'Baixa',
}

export const PRIORITY_GROUP_LABEL = {
  [PRIORITY.CRITICA]: 'Prioridade crítica',
  [PRIORITY.ALTA]: 'Prioridade alta',
  [PRIORITY.MEDIA]: 'Prioridade média',
  [PRIORITY.BAIXA]: 'Prioridade baixa',
}

// Rank numérico para AGRUPAR e ORDENAR. Agrupar pelo rótulo daria ordem
// alfabética (Alta, Baixa, Crítica, Média) — o Vuetify ordena o valor da
// propriedade de agrupamento, não a semântica.
export const PRIORITY_RANK = {
  [PRIORITY.CRITICA]: 1,
  [PRIORITY.ALTA]: 2,
  [PRIORITY.MEDIA]: 3,
  [PRIORITY.BAIXA]: 4,
}

export const RANK_TO_PRIORITY = Object.keys(PRIORITY_RANK).reduce((acc, nivel) => {
  acc[PRIORITY_RANK[nivel]] = nivel
  return acc
}, {})

// NOTA: Pesos da priorização — FALLBACK, não fonte de verdade.
//
// O backend calculará `priority` e mandará pronto (mesmo contrato do
// central-config: "o front NUNCA calcula/grava status"). Estes pesos existem
// para (a) rodar com mock antes do backend e (b) documentar a regra acordada,
// para que a implementação do servidor tenha um número a bater. Assim que o
// campo vier no payload, ele vence — ver `journey-adapters.js`.
export const PRIORITY_WEIGHTS = {
  SLA_POR_DIA: 8,
  SLA_TETO: 40,
  INTERACAO_CARENCIA_DIAS: 3,
  INTERACAO_POR_DIA: 3,
  INTERACAO_TETO: 25,
  FASE_ENTRADA: 20,
  FASE_COMPLIANCE: 15,
  FASE_DEMAIS: 5,
  PATRIMONIO: [
    { minimo: 5000000, pontos: 15 },
    { minimo: 1000000, pontos: 10 },
    { minimo: 300000, pontos: 5 },
  ],
}

export const PRIORITY_THRESHOLDS = {
  [PRIORITY.CRITICA]: 70,
  [PRIORITY.ALTA]: 45,
  [PRIORITY.MEDIA]: 20,
}

export const SLA_SEVERITY = {
  VENCIDO: 'vencido',
  ATENCAO: 'atencao',
  OK: 'ok',
  SEM_SLA: 'sem_sla',
}

// Dias restantes a partir dos quais o SLA deixa de ser "atenção" (âmbar).
export const SLA_DIAS_ATENCAO = 2

export const SEM_ACAO_DISPONIVEL =
  'Sem fluxo dedicado na plataforma — conclua manualmente quando terminar'

export const COLUNA_JORNADA_VAZIA = '—'

// --- Fase de validação de usabilidade ---
// O modal-esboço não executa nada: existe para o profissional percorrer a
// jornada inteira e dizer se o CAMINHO faz sentido, antes de amarrarmos cada
// passo ao seu fluxo real (que exige ajuste nos modais de Compliance, IPS etc.).
export const PASSO_ESBOCO_TITULO = 'Etapa da jornada'
export const PASSO_ESBOCO_RODAPE =
  'Esta etapa ainda não executa a ação — estamos validando o fluxo. A ação real entra na próxima fase.'
export const PASSO_ESBOCO_BOTAO = 'Entendi'
